import IconButton from 'components/iconbutton/IconButton';
import GearUserIcon from 'components/icons/GearUserIcon';
import HomeIcon from 'components/icons/HomeIcon';
import { SqRoutes } from 'constants/Routes';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActiveTab, getScreenTitle } from 'slices/AppUiSlice';
import { ModalKind, setModal } from 'slices/SqModalSlice';
import { doGoToLobby } from 'slices/SquaresSlice';
import { getIsUserLoggedIn } from 'slices/SqUserSlice';
import { ASComponentSize } from 'types/App.types';
import { TabPanel } from 'types/SqGame.types';
import styles from './NavBar.module.scss';

type NavBarProps = {
  className?: string;
};

const NavBar: React.FC<NavBarProps> = ({ className = '' }) => {
  const baseCls = `${styles.NavBarContainer} ${className}`;
  const dispatch = useAppDispatch();

  const screenTitle = useAppSelector(getScreenTitle);
  const activeTab = useAppSelector(getActiveTab);
  const isLoggedIn = useAppSelector(getIsUserLoggedIn);
  const navigate = useNavigate();

  const toLobbyNavigation = () => navigate(SqRoutes.Lobby);
  const onShowPlayer = () => dispatch(setModal({ kind: ModalKind.ShowPlayerModal, isVisible: true }));
  const onShowUser = () => dispatch(setModal({ kind: ModalKind.ShowUserSettingsModal, isVisible: true }));
  const backToLobby = () => dispatch(doGoToLobby(toLobbyNavigation));

  const showAction = activeTab === TabPanel.Scoreboard ? onShowPlayer : onShowUser;

  const showBackToLobbyNavButton = useMemo(() => {
    return activeTab === TabPanel.Scoreboard;
  }, [activeTab]);

  const showPlayerSettingsNavButton = useMemo(() => {
    return activeTab === TabPanel.Scoreboard || activeTab === TabPanel.Select || isLoggedIn;
  }, [activeTab, isLoggedIn]);

  return (
    <div className={baseCls}>
      {showBackToLobbyNavButton ? (
        <IconButton
          className={styles.NavBarLeftButtonAlignment}
          title="Go to the Lobby scene"
          aria-label="navigates user to the lobby scene"
          role="button"
          onClick={backToLobby}
          size={ASComponentSize.Small}
        >
          <HomeIcon size={40} />
        </IconButton>
      ) : (
        <div className={styles.NavBarLeftButtonAlignment} style={{ width: '40px', height: '40px' }}></div>
      )}
      <div className={`${styles.NavBarTitle}`}>{screenTitle}</div>
      {showPlayerSettingsNavButton ? (
        <IconButton
          className={styles.NavBarRightButtonAlignment}
          title="Settings"
          aria-label="user/player settings for the current scene"
          role="button"
          onClick={showAction}
          size={ASComponentSize.Small}
        >
          {/* <UserSettingsIcon size={40} /> */}
          <GearUserIcon size={40} />
        </IconButton>
      ) : (
        <div className={styles.NavBarRightButtonAlignment} style={{ width: '40px', height: '40px' }}></div>
      )}
    </div>
  );
};

export default NavBar;
